import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  storeList: [],
  storeFormExtendedList: [],
  storeDetail: [],
  storeFormList: [],
  loading: false,
  error: undefined,
};

const storeSlice = createSlice({
  name: "store",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchStoreList(state, action) {
      state.storeList = action.payload;
      state.loading = false;
    },
    fetchStoreFormExtendedList(state, action) {
      state.storeFormExtendedList = action.payload;
      state.loading = false;
    },
    fetchStoreFormList(state, action) {
      state.storeFormList = action.payload;
      state.loading = false;
    },
    fetchStoreFormListClear(state) {
      state.storeFormList = [];
      state.loading = false;
    },
    fetchStoreDetail(state, action) {
      state.storeDetail = action.payload;
      state.loading = false;
    },
  },
});

export const storeActions = storeSlice.actions;

export default storeSlice.reducer;
